import React from "react";
import styles from "./backButton.scss";
import history from "../../../../history";
import { getIconUrl } from "../../../../services/asset";

const BackButton = ({ text }) => (
  <button
    className={styles.button}
    type="button"
    onClick={() => history.goBack()}
  >
    <img alt="" src={getIconUrl("chevron-left.svg")} />
    {text}
  </button>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/MobileFooterButtons/BackButton/index.tsx